import { Injectable } from '@angular/core';
//import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class IdentityApiService {
    readonly baseUrl = 'http://identitydev.sunagile.com/api/';
    //readonly baseUrl = 'http://localhost:47088/';
        
    protected modulesList = [
        {
            "index": 1,
            "code": "PLANNING_WEB",
            "value": "http://planningwebstg.sunagile.com/demo",
            "external": true
        },
        {
            "index": 2,
            "code": "ENFORCEMENTS_WEB",
            "value": "signIn?target=http://enforcementswebdev.sunagile.com/demo",
            "external": false
        },
        {
            "index": 3,
            "code": "PREAPPS_WEB",
            "value": "signIn?target=http://preappswebdev.sunagile.com/demo",
            "external": false
        },
        {
            "index": 4,
            "code": "BUILDING_CONTROL_WEB",
            "value": "signIn?target=http://buildingcontrolwebdev.sunagile.com/demo",
            "external": false
        },
        {
            "index": 5,
            "code": "LAND_CHARGES_WEB",
            "value": "signIn?target=http://landchargeswebdev.sunagile.com/demo",
            "external": false
        },
        {
            "index": 7,
            "code": "CP_GIS",
            "value": "http://agilegisnextdev.azurewebsites.net/",
            "external": true
        }
    ]

    constructor() {

    }
    
    async getModules(): Promise<Array<any>> {
        //const data = await this.http.get<Array<any>>(`${this.baseUrl}menu`);
        const data = await fetch(`${this.baseUrl}menu`);
        return (await data.json()) ?? [];
    }
}
